// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newchat-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 380px;
}

.newchat-content {
  padding: 30px 24px 30px 24px;
  gap: 24px;
  background: #fefefe;
  border: 1px solid #e8ecef;
  border-radius: 12px;
}

.newchat-content h4 {
  font-weight: 600;
  letter-spacing: 0.5px;
  text-align: left;
  width: fit-content;
  letter-spacing: -0.5px;
}

.newchat-content .form-group {
  margin-bottom: 0px;
}

.newchat-content .form-group label {
  color: #141718;
}`, "",{"version":3,"sources":["webpack://./src/Components/NewChat/newchat.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,4BAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAGA;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,cAAA;AAAF","sourcesContent":[".newchat-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 380px;\n}\n\n.newchat-content {\n  padding: 30px 24px 30px 24px;\n  gap: 24px;\n  background: #fefefe;\n  border: 1px solid #e8ecef;\n  border-radius: 12px;\n\n}\n\n.newchat-content h4 {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-align: left;\n  width: fit-content;\n  letter-spacing: -0.5px;\n}\n\n.newchat-content .form-group {\n  margin-bottom: 0px;\n}\n\n.newchat-content .form-group label {\n  color: #141718;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
